var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFullScreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 27.778,
    viewBox: "0 0 29.872 27.778",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Light_Scan",
    "data-name": "Iconly/Light/Scan",
    transform: "translate(0 0.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Scan",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke-1",
    d: "M0,0",
    transform: "translate(0 14.395)",
    fill: "none",
    stroke: "#464547",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-3",
    d: "M21.709,7.985v-2.3A5.682,5.682,0,0,0,16.026,0H14.192",
    transform: "translate(7.413 0)",
    fill: "none",
    stroke: "#464547",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-5",
    d: "M1.87,7.985v-2.3A5.682,5.682,0,0,1,7.553,0H9.435",
    transform: "translate(0.977 0)",
    fill: "none",
    stroke: "#464547",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-7",
    d: "M21.709,9.455v6.2a5.682,5.682,0,0,1-5.683,5.683H14.192",
    transform: "translate(7.413 4.939)",
    fill: "none",
    stroke: "#464547",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-9",
    d: "M1.87,9.455v6.2a5.682,5.682,0,0,0,5.683,5.683H9.435",
    transform: "translate(0.977 4.939)",
    fill: "none",
    stroke: "#464547",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullScreen);
export default __webpack_public_path__ + "static/media/fullScreen.4ee4725710a38a33b4e274507f3fd9ae.svg";
export { ForwardRef as ReactComponent };